import { render, staticRenderFns } from "./file-upload-widget.vue?vue&type=template&id=71fff5a0&scoped=true&"
import script from "./file-upload-widget.vue?vue&type=script&lang=js&"
export * from "./file-upload-widget.vue?vue&type=script&lang=js&"
import style0 from "./file-upload-widget.vue?vue&type=style&index=0&id=71fff5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fff5a0",
  null
  
)

export default component.exports